export function normalizeImage(image) {
  if (!image || typeof image !== 'object') {
    return null
  }

  return {
    src: image.sourceUrl || image.url || image.mediaItemUrl || '',
    alt: image.altText || image.alt || '',
  }
}

export function normalizeSectionId(section, fallback) {
  const candidate = section?.sectionId || section?.section_id

  if (typeof candidate === 'string' && candidate.trim()) {
    return candidate.trim()
  }

  return fallback
}

export function normalizeAnchor(raw, fallback = '#') {
  if (!raw || typeof raw !== 'string') {
    return fallback
  }

  const value = raw.trim()

  if (!value) {
    return fallback
  }

  if (value.startsWith('#') || value.startsWith('/') || value.startsWith('http://') || value.startsWith('https://')) {
    return value
  }

  return `#${value}`
}

export function normalizeLink(link, fallback = '') {
  if (!link) {
    return null
  }

  if (typeof link === 'string') {
    return {
      url: link,
      title: '',
      target: '',
    }
  }

  return {
    url: link.url || '',
    title: link.title || link.linkText || '',
    target: link.target || '',
  }
}

export function normalizeFaIconValue(value, fallback = 'fa-circle') {
  if (!value || typeof value !== 'string') {
    return fallback
  }

  const trimmed = value.trim()
  if (!trimmed) {
    return fallback
  }

  return trimmed.startsWith('fa-') ? trimmed : `fa-${trimmed}`
}

export function normalizePathname(pathname) {
  if (typeof pathname !== 'string') {
    return '/'
  }

  const trimmed = pathname.trim()
  if (!trimmed || trimmed === '/') {
    return '/'
  }

  return trimmed.replace(/\/+$/, '') || '/'
}

export function getInPageAnchorId(rawHref, currentPathname = '/') {
  if (!rawHref || typeof rawHref !== 'string') {
    return null
  }

  const value = rawHref.trim()
  if (!value || value === '#') {
    return null
  }

  try {
    const basePath = normalizePathname(currentPathname || '/')
    const url = new URL(value, `https://example.test${basePath}`)
    const hash = url.hash
    if (!hash || hash === '#') {
      return null
    }

    const targetPath = normalizePathname(url.pathname)
    if (targetPath !== basePath) {
      return null
    }

    return decodeURIComponent(hash.slice(1))
  } catch {
    return null
  }
}
